import { render, staticRenderFns } from "./CodeEditorWidget.vue?vue&type=template&id=248f1758"
import script from "./CodeEditorWidget.vue?vue&type=script&lang=js"
export * from "./CodeEditorWidget.vue?vue&type=script&lang=js"
import style0 from "./CodeEditorWidget.vue?vue&type=style&index=0&id=248f1758&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports